import { Col, Form, FormControl, FormGroup, Row } from "react-bootstrap";

import { useTranslateContext } from "../../contexts/translate.context";

export interface IInfractionRecordProps {
    title: any,
    isEdit: boolean,
    identifier: boolean,
    viewOnly?: boolean,

    created?: any,
    updated?: any,
    setCreated?: any,
    setUpdated?: any,
    listEstate: any,

    estateId: any,
    launch: any,
    name: any,
    reason: any,
    justification: any,
    setEstateId: any,
    setLaunch: any,
    setName: any,
    setReason: any,
    setJustification: any,
}

export const InfractionRecord: React.FC<IInfractionRecordProps> = (props: IInfractionRecordProps) => {

    const { display } = useTranslateContext();

    return (
        <>
            <Row>
                <Col>
                    <FormGroup>
                        <Form.Label htmlFor="form-estate">{display.label.estate}</Form.Label>
                        <Form.Select id="form-estate" name="estate" 
                            value={props.estateId} 
                            onChange={(e: any) => props.setEstateId(e.target.value)}
                        >
                            { props.estateId === 0 ? (
                                <option value="">...</option>
                            ) : null }
                            { props.listEstate.map((iterator: any, idx: number) => (<option key={idx} value={iterator.id}>{iterator.name}</option>)).sort((a : any, b : any) => { return a.props.children > b.props.children ? 1 : -1; }) }
                        </Form.Select>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col sm="3">
                    <FormGroup>
                        <Form.Label htmlFor="form-launch">{display.label.date_launch}</Form.Label>
                        <FormControl id="form-launch" name="launch" placeholder={display.example.launch}
                            disabled={!props.isEdit}
                            readOnly={true}
                            value={props.launch}
                            onChange={e => props.setLaunch(e.target.value)}
                        />
                    </FormGroup>
                </Col>
                <Col sm="9">
                    <FormGroup>
                        <Form.Label htmlFor="form-name">{display.label.name}</Form.Label>
                        <FormControl id="form-name" name="name" placeholder={display.example.name}
                            disabled={!props.isEdit}
                            value={props.name}
                            onChange={e => props.setName(e.target.value)}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Form.Label htmlFor="form-reason">{display.label.reason}</Form.Label>
                        <FormControl as="textarea" rows={3} id="form-reason" name="reason" placeholder={display.example.reason}
                            disabled={!props.isEdit}
                            value={props.reason}
                            onChange={e => props.setReason(e.target.value)}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Form.Label htmlFor="form-justification">{display.label.justification}</Form.Label>
                        <FormControl as="textarea" rows={3} id="form-justification" name="justification" placeholder={display.example.justification}
                            disabled={!props.isEdit}
                            value={props.justification}
                            onChange={e => props.setJustification(e.target.value)}
                        />
                    </FormGroup>
                </Col>
            </Row>
        </>
    );

}

export default InfractionRecord;
